/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Components
import PageWrapper from 'components/PageWrapper'
import Balance from 'components/Balance'
import RoundedButton from 'components/RoundedButton'
import {
  MembershipSubscriptionModal,
  SuspendedMembershipModal
} from 'components/MembershipSubscriptionModal'
import Badge from 'components/Badge'
import { getPersonalizeContent } from 'api/personalize'
import { simplifyPromotions } from 'utils/personalize'

// Analytics
import { trackEvent } from 'analytics/trackFunctions'

// Constants and contexts
import WORDING, { buttonText } from 'constants/wording'
import { MeContext } from 'contexts/me'
import { hasActiveMembership } from 'utils'

// Assets
import SuspendedMembership from 'components/SuspendedMembership'
import { hasSuspendedMembership } from 'utils/membershipFunction'
import ChargeMoney from 'assets/images/chargeMoney.svg'
import creditProfile from 'assets/images/creditProfile.svg'
import wayniPlus from 'assets/images/wayniPlus.svg'
import CreditCard from 'assets/images/credit-card.png'
import WalletAdd from 'assets/images/wallet-add.png'

import BannerCarrousel from './BannerCarrousel'
import DiscountsSection from './DiscountsSection'

const Home = () => {
  // modals
  const [openSubsModal, setOpenSubsModal] = useState(false)
  const [openSuspendedMembershipModal, setOpenSuspendedMembershipModal] =
    useState(false)
  const [personalizeContent, setPersonalizeContent] = useState(null)

  const { me } = useContext(MeContext)

  const navigate = useNavigate()

  const membershipIsActive = hasActiveMembership(me?.subscriber_products)
  const membershipIsSuspended = hasSuspendedMembership(me?.subscriber_products)

  const fetchPersonalize = async () => {
    try {
      const { data, status } = await getPersonalizeContent()
      if (status === 200) {
        setPersonalizeContent(data)
      } else {
        trackEvent({
          eventName: 'bille_inicio_error_personalize',
          props: {
            error: JSON.stringify(data)
          }
        })
      }
    } catch (error) {
      trackEvent({
        eventName: 'bille_inicio_error_catch_personalize',
        props: {
          error: error.message ?? JSON.stringify(error)
        }
      })
    }
  }

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_inicio' })
    fetchPersonalize()
  }, [])

  return (
    <>
      <PageWrapper isSectionHome title='Inicio'>
        <section className='sm:max-w-[23rem] mt-3 mb-4 sm:mt-14 sm:flex sm:flex-col mx-auto'>
          {/* tarjeta y saldo */}
          <div className='flex justify-center items-start'>
            <Balance />
          </div>
          {/* Botonera */}
          <div className='grid grid-cols-3 w-full my-8 gap-3 gap-y-4'>
            <RoundedButton
              title={buttonText.chargeMoney}
              image={ChargeMoney}
              onClick={() => {
                trackEvent({ eventName: 'bille_inicio_boton_carga_dinero' })
                navigate('/cargar-dinero')
              }}
            />
            <RoundedButton
              title={buttonText.transfers}
              image={CreditCard}
              onClick={() => {
                trackEvent({
                  eventName: 'bille_inicio_boton_transferir'
                })
                navigate('/transferencias')
              }}
            />
            <RoundedButton
              title={buttonText.advances}
              image={WalletAdd}
              onClick={() => {
                trackEvent({
                  eventName: 'bille_boton_wayni_credito'
                })
                navigate('/wayni-credito')
              }}
              badge={
                <Badge className='!py-0' variant='GRADIENT_GREEN'>
                  <span>Tasa 0</span>
                </Badge>
              }
            />
          </div>
          <div className='grid grid-cols-2 w-full my-8 sm:mb-8 sm:mt-1 px-4'>
            <RoundedButton
              title={buttonText.creditProfile}
              image={creditProfile}
              onClick={() => {
                if (membershipIsActive) {
                  navigate('/perfil-crediticio')
                } else {
                  setOpenSubsModal(true)
                  setOpenSuspendedMembershipModal(true)
                }
                trackEvent({
                  eventName: 'bille_inicio_boton_perfil_crediticio'
                })
              }}
            />
            <RoundedButton
              title={
                membershipIsActive
                  ? buttonText.membership
                  : buttonText.membershipFalse
              }
              image={wayniPlus}
              onClick={() => {
                navigate('/suscripcion')
                trackEvent({
                  eventName: membershipIsActive
                    ? 'bille_inicio_boton_sumarme_wayniplus'
                    : 'bille_inicio_boton_wayniplus'
                })
              }}
            />
          </div>

          {membershipIsActive ? (
            <DiscountsSection
              promos={simplifyPromotions(personalizeContent, {
                id: 'promotion-'
              })}
            />
          ) : null}

          <BannerCarrousel
            banners={simplifyPromotions(personalizeContent, {
              id: 'banner-'
            })}
          />

          {membershipIsSuspended ? (
            <SuspendedMembership
              className='border border-red-500 rounded-[10px] mt-4 p-3 flex flex-row items-center justify-around'
              paragraphText={WORDING.SUSPENDED_MEMBERSHIP}
              eventName='bille_boton_pagar_membresia_suspendida'
            />
          ) : null}
        </section>
      </PageWrapper>

      {membershipIsSuspended ? (
        // Modal membresia suspendida
        <SuspendedMembershipModal
          isModalOpen={openSuspendedMembershipModal}
          setIsModalOpen={setOpenSuspendedMembershipModal}
        />
      ) : (
        <MembershipSubscriptionModal
          titleSection='tu perfil crediticio'
          isOpen={openSubsModal}
          setIsOpen={setOpenSubsModal}
          primaryButtonFunction={() => {
            navigate('/suscripcion/perfil-crediticio')
            setOpenSubsModal(false)
          }}
        />
      )}
    </>
  )
}

export default Home
